import { render, staticRenderFns } from "./TenantUserBadge.vue?vue&type=template&id=d38980ce"
import script from "./TenantUserBadge.vue?vue&type=script&lang=js"
export * from "./TenantUserBadge.vue?vue&type=script&lang=js"
import style0 from "./TenantUserBadge.vue?vue&type=style&index=0&id=d38980ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports